import type { ButtonHTMLAttributes } from 'react';

type Props = Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'id' | 'aria-label' | 'aria-labelledby' | 'aria-describedby' | 'disabled'> & {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};

/** Keep the visual track compact without making its touch target tiny. */
export function SettingsTouchSwitch({ checked, onCheckedChange, ...props }: Props) {
  return (
    <button
      {...props}
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onCheckedChange(!checked)}
      className="flex h-11 min-h-11 w-11 min-w-11 shrink-0 items-center justify-center rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <span aria-hidden="true" className={`pointer-events-none relative block h-6 w-11 rounded-full transition-colors ${checked ? 'bg-foreground' : 'bg-muted border border-border'}`}>
        <span className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full transition-transform ${checked ? 'translate-x-5 bg-background' : 'translate-x-0 bg-foreground'}`} />
      </span>
    </button>
  );
}
